import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CustomMoldedRubberProductsRoutingModule } from './custom-molded-rubber-products-routing.module';
import { CustomMoldedRubberProductsComponent } from './custom-molded-rubber-products.component';
import { PageHeaderModule } from '../page-header/page-header.module';
import { AGGridModule } from 'src/app/table/aggrid.module';
import { CtaFullWidthModule } from 'src/app/shared/cta-full-width/cta-full-width.module';
import { BlogLinksModule } from '../blog-links/blog-links.module';

@NgModule({
  declarations: [CustomMoldedRubberProductsComponent],
  imports: [
    CommonModule,
    CustomMoldedRubberProductsRoutingModule,
    PageHeaderModule,
    AGGridModule,
    CtaFullWidthModule,
    BlogLinksModule
  ]
})
export class CustomMoldedRubberProductsModule { }
